module.exports = __webpack_public_path__ + "img/204.rug.09b99273.svg";